import { useEditorStore } from '@/stores/editorStore';
import { useUIStore } from '@/stores/uiStore';
import { ClipboardManager } from '@/lib/clipboard';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Copy, Trash2, Undo, Redo, Save } from 'lucide-react';
import { useState } from 'react';

export function QuickFormatButtons() {
  const { getContentAsHTML, getContentAsPlainText, clearContent, undo, redo, canUndo, canRedo } =
    useEditorStore();

  const { showNotification } = useUIStore();
  const [copying, setCopying] = useState(false);

  const handleCopy = async () => {
    setCopying(true);
    const html = getContentAsHTML();
    const text = getContentAsPlainText();

    if (text.length > 3000) {
      showNotification('Content exceeds LinkedIn limit (3000 chars)', 'error');
      setCopying(false);
      return;
    }

    try {
      await ClipboardManager.copyToClipboard(html, text);
      showNotification('Copied to clipboard!', 'success');
    } catch (error) {
      showNotification('Failed to copy', 'error');
    } finally {
      setCopying(false);
    }
  };

  const handleClear = () => {
    if (confirm('Are you sure you want to clear all content?')) {
      clearContent();
      showNotification('Content cleared', 'info');
    }
  };

  return (
    <Card className="space-y-4">
      <h3 className="text-lg font-serif font-medium">Quick Actions</h3>

      <Button
        variant="primary"
        className="w-full h-12 text-base shadow-lg shadow-primary/20"
        onClick={handleCopy}
        disabled={copying}
      >
        <Copy className="w-5 h-5 mr-2" />
        {copying ? 'Copying...' : 'Copy to Clipboard'}
      </Button>

      <div className="grid grid-cols-2 gap-3">
        <Button variant="secondary" onClick={undo} disabled={!canUndo}>
          <Undo className="w-4 h-4 mr-2" /> Undo
        </Button>
        <Button variant="secondary" onClick={redo} disabled={!canRedo}>
          <Redo className="w-4 h-4 mr-2" /> Redo
        </Button>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Button variant="secondary" onClick={() => {}}>
          <Save className="w-4 h-4 mr-2" /> Save Draft
        </Button>
        <Button
          variant="ghost"
          className="text-error hover:bg-error/10 hover:text-error"
          onClick={handleClear}
        >
          <Trash2 className="w-4 h-4 mr-2" /> Clear All
        </Button>
      </div>
    </Card>
  );
}
